<template>
  <modal name="mynavi-dialog" :adaptive="true" :scrollable="true" height="auto">
    <div class="v--modal-close-top" v-loading.fullscreen.lock="fullscreenLoading" style="background-color: #244C42;">
      <el-button @click="closeMynaviDialog" icon="el-icon-circle-close-outline" style="font-size: 2rem;color:#fff;"
        type="text"></el-button>
    </div>
    <div class="setting" v-if="permissionType == 3">

      <div class="setting-item" style="text-align:center;">
        <p style="font-size: 1rem; font-weight: bold;">ダウンロードが完了しました！！！</p>
        <p style="font-size: 1rem; font-weight: bold;">今作成した履歴書をもとに<br>プロが好条件の正社員の勤め先をご紹介します！</p>

        <p style="display: inline-block; margin: 10px;">
          <img src="/static/renew2_img/mynavi_yagish_logo_20230929.png" alt="ヤギッシュ">
        </p>

        <p style="font-weight: bold;">ご同意いただいた方には追って連絡がいきますので<br>ご確認お願いいたします！</p>
        <br>
        <p style="font-size: 80%;">
          Yagishの<router-link id="footer-link-terms" :to="{ name: 'termsPage' }"
            target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{ name: 'policyPage' }"
            target="_blank">個人情報保護方針</router-link><br />
          (株)リアステージの<a href="https://mynavi.co.jp/privacy-policy" target="_blank">利用規約</a>、<a
            href="https://mynavi.co.jp/privacy-policy" target="_blank">個人情報保護方針</a>
        </p>
        <br>

        <p style="font-size: 1rem; font-weight: bold; margin-top: 10px;"><img src="/static/renew_img/check_icon.png"
            alt="同意する" style="height: 30px;">
          規約に同意して無料相談を希望する</p>
        <div class="text-center" style="padding:10px">
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success" v-if="isMynaviSended == false"
            style="background-color:#F60B26;border-color:#F60B26;font-size: 120%;"
            @click="$eventHub.$emit('send-mynavi-consult');">同意する</el-button>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success" v-if="isMynaviSended == true"
            style="background-color:#0F9934;border-color:#0F9934;" @click="closeMynaviDialog();">送信しました</el-button>
          <br />
        </div>
      </div>

    </div>
    <!--パターン１-->
    <div class="setting" v-else-if="permissionType == 2">
      <div class="setting-item" style="text-align: center;">
        <!--<p>ダウンロードが完了しました！！！</p>-->
        <p style="font-size: 1rem; font-weight: bold; color: #E85C0F;">「希望通りのバイトみつけられてますか?」</p>
        <p style="font-weight: bold; margin-top: 20px; margin-bottom: 20px;">
          アルバイト紹介では、今作成した履歴書をもとに<br>あなたの希望や条件に沿った<br>ぴったりなバイト先をご紹介します！！</p>

        <p style="display: inline-block; margin: 10px;"><img src="/static/renew2_img/mynavi_yagish_log_20231004.jpeg"
            alt="マイナビアルバイトとヤギッシュ"></p>

        <div style="display: inline-block; min-width: 100%; text-align: center;">
          <p style="font-weight: bold; margin-top: 20px; margin-bottom: 20px;"><img
              src="/static/renew_img/check_icon.png" style="width: 40px;">規約に同意して無料相談を希望
          </p>
        </div>

        <p style="font-size: 0.8rem; padding: 5px;">
          株式会社マイナビアルバイト紹介サービス<br><a href="https://baito.mynavi.jp/user/html/kiyaku.html"
            target="_blank">利用規約、個人情報の取り扱いについて</a><br>

          Yagishの<a href="/terms" class="" id="footer-link-terms" target="_blank">利用規約</a>、<a href="/privacy" class=""
            id="footer-link-policy" target="_blank">個人情報保護方針</a>
        </p><!---->

        <div class="text-center">
          <button type="button" class="el-button el-button--success" :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'"
            style="background-color: rgb(227, 22, 92); border-color: rgb(227, 22, 92); font-size: 140%;"><!----><!----><span>利用する</span></button><!---->
          <button type="button" class="el-button el-button--success"
            :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'"
            style="background-color: #808080; border-color: #808080; font-size: 140%;"><!----><!----><span>利用しない</span></button><!---->
        </div>

        <p style="font-size: 0.8rem; padding: 5px;">※東京23区のお仕事限定</p>
      </div>
    </div>
    <!--パターン２-->
    <div class="setting" v-else-if="permissionType == 11">
      <div class="setting-item" style="text-align: center;">
        <!--<p>ダウンロードが完了しました！！！</p>-->
        <p style="font-size: 1.2rem; font-weight: bold; color: #E85C0F;">バイト選びって難しいですよね･･･?</p>
        <p style="font-weight: bold; margin-top: 20px; margin-bottom: 20px;">
          「面接に失敗したときどうしよう･･･」<br>「このバイト選びが正解だったのかな･･･」<br>私たちアルバイト紹介はそんな不安に寄り添い<br>解決できるようサポートします。</p>
        <p style="font-weight: bold; margin-top: 20px; margin-bottom: 20px;">
          「自分に自信がついた!!」<br>「しっくりくるバイト選びができた!!」<br>専任スタッフと一緒に<br>”<span
            style="color: #E85C0F;">成功する</span>”バイト選びをしてみませんか?</p>

        <p style="display: inline-block; margin: 10px;"><img src="/static/renew2_img/mynavi_yagish_log_20231004.jpeg"
            alt="マイナビアルバイトとヤギッシュ"></p>

        <div style="display: inline-block; min-width: 100%; text-align: center;">
          <p style="font-weight: bold; margin-top: 20px; margin-bottom: 20px;"><img
              src="/static/renew_img/check_icon.png" style="width: 40px;">規約に同意して無料相談を希望
          </p>
        </div>
        <p style="font-size: 0.8rem; padding: 5px;">こちらからお電話させていただきます</p>

        <p style="font-size: 0.8rem; padding: 5px;">
          株式会社マイナビアルバイト紹介サービス<br><a href="https://baito.mynavi.jp/user/html/kiyaku.html"
            target="_blank">利用規約、個人情報の取り扱いについて</a><br>

          Yagishの<a href="/terms" class="" id="footer-link-terms" target="_blank">利用規約</a>、<a href="/privacy" class=""
            id="footer-link-policy" target="_blank">個人情報保護方針</a>
        </p><!---->

        <div class="text-center">
          <button type="button" class="el-button el-button--success" :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'"
            @click="$eventHub.$emit('send-mynavi-consult');"
            style="background-color: rgb(227, 22, 92); border-color: rgb(227, 22, 92); font-size: 140%;width: 140px;"><!----><!----><span>利用する</span></button><!---->
          <button type="button" class="el-button el-button--success"
            :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" @click="closeMynaviDialog();"
            style="background-color: #808080; border-color: #808080; font-size: 140%;width: 140px;"><!----><!----><span>利用しない</span></button><!---->
        </div>

        <p style="font-size: 0.8rem; padding: 5px;">※東京23区のお仕事限定</p>
      </div>
    </div>
    <div class="setting" v-else-if="permissionType == 1">

      <p style="font-size: 1.3rem; font-weight: bold;color:#fff; text-align: center;background-color: #244C42;">
        履歴書ダウンロード完了</p>
      <p style="font-size: 2rem; font-weight: bold;color:#fff; text-align: center;background-color: #244C42;"><i
          class="el-icon-download"></i></p>
      <div class="setting-item" style="text-align: center;">
        <img src="/static/renew2_img/mynabi_images/mynabi_bait_image20231108001_01.png" style="width:100%;" />
        <div style="width: 100%;display: flex">
          <img src="/static/renew2_img/mynabi_images/mynabi_bait_image20231108001_02.png" style="width:24.93333%;" />
          <img src="/static/renew2_img/mynabi_images/mynabi_bait_image20231108001_03.png"
            style="width:49.2%;cursor: pointer;" @click="$eventHub.$emit('send-mynavi-consult');" />
          <img src="/static/renew2_img/mynabi_images/mynabi_bait_image20231108001_04.png" style="width:25.866666%;" />
        </div>
        <img src="/static/renew2_img/mynabi_images/mynabi_bait_image20231108001_05.png" style="width:100%;" />
        <!-- <a href="" ><img src="/static/renew2_img/mynabi_images/mynabi_bait_image20231108_2.png" style="width:100%;" /></a>
        <img src="/static/renew2_img/mynabi_images/mynabi_bait_image20231108_2_1.png" style="width:100%;" /> -->
        <!-- <map name="ImageMap">
          <area shape="poly" coords="590,1371,589,1370,690,1364,692,1394,592,1398,592,1398" href="#" alt="" />
          <area shape="poly" coords="707,1364,1019,1353,1019,1383,707,1392,707,1392" href="#" alt="" />
          <area shape="poly" coords="480,1408,581,1403,582,1431,482,1434,482,1434" href="#" alt="" />
          <area shape="poly" coords="596,1403,794,1397,794,1424,598,1431,650,1439" href="#" alt="" />
          <area shape="poly" coords="284,1474,863,1452,862,1596,287,1615,286,1537" href="javascript:alert(2)" alt="" />
          <area shape="circle" coords="1080,70,39" href="#" onclick="alert(1)" alt="" />
        </map> -->
        <p style="font-size: 0.8rem; padding: 5px;">
          株式会社マイナビアルバイト紹介サービス<br><a href="https://baito.mynavi.jp/user/html/kiyaku.html"
            target="_blank">利用規約、個人情報の取り扱いについて</a><br>

          Yagishの<a href="/terms" class="" id="footer-link-terms" target="_blank">利用規約</a>、<a href="/privacy" class=""
            id="footer-link-policy" target="_blank">個人情報保護方針</a>
        </p><!---->
      </div>
    </div>
  </modal>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<script>
export default {
  components: {
  },
  data: function () {
    return {
      clearLocalStorageConfirmVisible: false,
      currentFormat: {},
      formatid: '',
      previewHtml: '',
      permissionType: 1,
      isMynaviSended: false,
      fullscreenLoading: false,
      clientId: 'mynavi_mail',
      username: '',
      baite_title: 'バイト',
      isAgree: true
    }
  },
  created: function () {
    const app = this
    this.$iterateStorage(function (value, key, iterationNumber) {
      //console.log all the kay/value pairs
      if (key === 'basicData') {
        app.username = value.lastName + '_' + value.firstName
      }
    }, function (err) {
      if (!err) {
        console.log('Iteration has completed');
      }
    })
  },
  computed: {
    cleanedPreviewHtml: function () {
      // PDFで文字化けするやつを変換しておく
      return this.previewHtml
    },
    pdfFormData: function () {
      const formData = new FormData()
      formData.append('app_html', this.cleanedPreviewHtml)
      formData.append('pdf_option', 'A4')
      return formData
    }
  },
  methods: {
    openMynaviDialog: function (id, html, permissionType) {
      this.formatid = id
      this.previewHtml = html.$el.innerHTML
      this.$modal.show('mynavi-dialog')
      this.clearLocalStorageConfirmVisible = false
      this.permissionType = permissionType

      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('dialog_name', 'mynavi_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '2')
      formData.append('site_flag', 'r')
      formData.append('app_flag', this.$site.appFlag)
      const app = this
      this.$axios.post(this.$varuna.endPoints.displayDialog, formData, { timeout: 60000 })
      this.$iterateStorage(function (value, key, iterationNumber) {
        //console.log all the kay/value pairs
        if (key === 'basicData') {
          app.username = value.lastName + '_' + value.firstName
        }
      }, function (err) {
        if (!err) {
          console.log('Iteration has completed');
        }
      })
    },
    closeMynaviDialog: function () {
      this.$modal.hide('mynavi-dialog')
      this.clearLocalStorageConfirmVisible = false
      //this.$router.push('/mypage')

    },
    confirmWin: function () {
      confirm('応募するデータを送信します。よろしいでしょうか。')
    },
    clearLocalStorage: function () {
      this.$clearStorage()
      window.location = '/'
    },
    createFilename: function (ext) {
      const now = new Date()
      const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX
      const dateString = this.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
      return `${prefix}${this.formatid}${dateString}.${ext}`
    },
    sendMynaviConsult: async function () {
      if (!this.isAgree) {
        this.$message({
          message: 'チェックしてから同意ボタンを押してください。',
          type: 'error'
        })
        return
      }
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('yaginame', this.username)
      formData.append('app_flag', this.$site.appFlag)
      formData.append('dialog_name', 'mynavi_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '3')
      formData.append('reqflg', '2')
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.sendMynaviBaite, formData, { timeout: 60000 })
        .then(function (response) {
          app.isMynaviSended = true
          app.$eventHub.$emit('update_rt_condition', app.clientId, app.permissionType)
          app.closeMynaviDialog()
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('send-mynavi-consult', this.sendMynaviConsult)
    this.$eventHub.$on('open-mynavi-dialog', this.openMynaviDialog)
    this.$eventHub.$on('popstate', this.closeMynaviDialog)
  },
  destroyed: function () {
    this.$eventHub.$off('send-mynavi-consult', this.sendMynaviConsult)
    this.$eventHub.$off('open-mynavi-dialog', this.openMynaviDialog)
    this.$eventHub.$off('popstate', this.closeMynaviDialog)
  }
}
</script>
